<template>
    <div>
        <modal
        class="new-modal-default"
        :name="modal_name"
        transition="nice-modal-fade"
        :delay="100"
        :width="700"
        :height="530"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">STEP 1/2 : TEAM INFORMATION</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideSelf"></span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout p-6">
                        <div class="form-group">
                            <input class="inputFieldNew mt-6" type="text" v-model="teamName" placeholder="Enter Team Name" v-validate="'required'" name="team_name" @blur="checkTeamName" @input="teamNameExists ? teamNameExists = false : ''">
                            <label class="inputLabel fs-14 fw-600 ml-3">
                                Team Name
                                <sup class="fs-14 ml-02 mandatory" style="color: #b10505 !important">*</sup>
                            </label>
                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('team_name')">Team Name is required</span>
                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-if="!errors.has('team_name') && teamNameExists">Team name already exists</span>
                        </div>
                        <div class="mt-8">
                            <span class="text-secondary fs-14 fw-600 mt-2 ml-3">
                                Description
                            </span>
                            <textarea-autosize class="digi-textarea white-background bordered" v-model="description" placeholder="Enter Description" style="height: 7em" maxlength="1000" />
                            <span class="editcharacter-count text-grey" style="margin-top: 2px">{{1000 - description.length}}/1000</span>
                        </div>
                        <div class="mt-4">
                            <span class="text-secondary whiteSpace fs-14 fw-600 ml-3">
                                Group Email
                                <sup class="fs-14 ml-02 mandatory" style="color: #b10505 !important">*</sup>
                            </span>
                            <div class="email-grey input-group mt-2">
                                <input type="text" name="team_email" class="form-control-email-dropdown" v-model="teamEmail" placeholder="Enter Group Email" v-validate="{required: true, regex: /^[a-zA-Z0-9-_.]+$/}" @blur="checkTeamEmail">
                                <span class="input-group-addon-email pl-4" style="border-bottom: 1px solid #a9aaad;padding-top: 2px;font-size: 20px;border-left: 1px solid #3f3f3f">@</span>
                                <multiselect name="team_email" v-validate="'required'" class="emailselect-multiselect no-default-icon down-arrow" v-model="teamEmailDomain" :loading="isLoading.domains" :options="domains" @open="getAllDomain" @search-change="getAllDomain" @close="checkTeamEmail" style="width: 180px"></multiselect>
                            </div>
                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('team_email')">Please enter valid email</span>
                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-if="!errors.has('team_email') && teamEmailExists">Email already exists</span>
                        </div>
                        <div class="mt-8 text-center">
                            <button class="btn btn-new-primary btn-des" @click="addMembers">Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            domains: [],
            allow_public_domain: false,
            teamName: "",
            teamNameExists: false,
            description: "",
            teamEmail: "",
            teamEmailExists: false,
            teamEmailDomain: "",
            isLoading: {
                domains: false,
            },
        }
    },
    props: ["modal_name"],
    methods: {
        hideSelf() {
            this.teamName = "";
            this.teamNameExists = false;
            this.description = "";
            this.teamEmail = "";
            this.teamEmailExists = false;
            this.teamEmailDomain = "";
            this.$modal.hide(this.modal_name);
        },
        
        async checkTeamName() {
            let res = await this.$http.post("/teams/check_if_team_name_exists", { team_name: this.teamName });
            if (res.data.status_id == 1) {
                this.teamNameExists = res.data.exists;
            }
        },

        async checkTeamEmail() {
            if (this.teamEmail && this.teamEmailDomain) {
                let res = await this.$http.post("/teams/check_if_email_exists", { email: this.teamEmail + "@" + this.teamEmailDomain });
                if (res.data.status_id == 1) {
                    this.teamEmailExists = res.data.exists;
                }
            }
        },

        // Getting Domains
        async getAllDomain(key) {
            this.isLoading.domains = true;
            let res = await this.$http.get("/employees/get_company_domains");
            if (res.data.status_id == 1) {
                this.domains = res.data.response;
                if (this.allow_public_domain) {
                    this.getPublicDomain(key);
                }
                this.isLoading.domains = false;
            }
        },

        // Getting Public Domains
        async getPublicDomain(key) {
            let params = {
                search_key: "",
                skip: 0,
                limit: 10
            };
            if (key) {
                params.search_key = key;
            }
            if (params.search_key) {
                this.getDomain = [];
            }
            let res = await this.$http.post("/search_domain", params);
            if (res.data.status_id == 1) {
                    res.data.response.forEach(x => {
                        if (!this.domains.includes(x)) {
                            this.domains.push(x);
                        }
                });
            }
        },

        //Checking if public domain is allowed or not
        async checkPublicDomain() {
            let res = await this.$http.get("/company/get_public_domain");
            if (res.data.status_id == 1) {
                if ("allow_public_domain" in res.data.response) {
                    if (res.data.response.allow_public_domain) {
                        this.allow_public_domain = true;
                    }
                }
            }
        },

        addMembers() {
            this.$validator.validateAll().then(result => {
                if (result && !this.teamNameExists && !this.teamEmailExists) {
                    localStorage.setItem("teamInfo", JSON.stringify({
                        name: this.teamName,
                        description: this.description,
                        email: this.teamEmail + "@" + this.teamEmailDomain,
                    }));
                    this.$modal.show("addNewMembersModal");
                    this.hideSelf();
                }
            });
        }
    },
    created() {
        this.checkPublicDomain();
    }
}
</script>

<style scoped>
    .grey-tab {
        border-radius: 5px;
        background: #f5f5f5;
        color: #232323;
    }
</style>


// WEBPACK FOOTER //
// src/components/CreateTeamModal.vue